module.exports = __webpack_public_path__ + "img/new_logo_symbol_x_shuriken_inverted.cbdffbfe.svg";